<template>
  <VDialog v-model="dialog" width="500px" persistent>
    <VCard>
      <VBtn
        absolute
        style="right: 0"
        class="mt-1"
        icon
        @click="closeIfLastItem"
      >
        <VIcon>mdi-close</VIcon>
      </VBtn>
      <VCardTitle class="text-center">{{ $t("spaceLeft") }}</VCardTitle>
      <VCardText
        v-for="/**
         * @type item {Object}
         * @property stillageColumnCode
         * @property sortOrder
         */ item in boxDetails"
        :key="item.id"
        :class="{ done: item.done }"
      >
        <div class="d-flex align-center pl-0 pt-2 pb-2">
          {{ $t("place") }}:
          <h3 class="font-weight-bold ml-1">
            {{ item.stillageColumnCode }}{{ item.sortOrder }}
          </h3>
        </div>

        <div
          class="d-flex align-center justify-space-between"
          v-if="!item.done"
        >
          <VBtn
            class="flex-grow-1 mr-3"
            color="success"
            @click="placeRemained(item, false)"
            >{{ $t("yes") }}</VBtn
          >
          <VBtn
            class="flex-grow-1"
            color="error"
            @click="placeRemained(item, true)"
            >{{ $t("no") }}</VBtn
          >
        </div>
        <VueIcon
          v-if="item.done"
          class="plus_btn"
          style="fill: #88d755"
          icon="checkIcon"
        ></VueIcon>
      </VCardText>
    </VCard>
  </VDialog>
</template>

<script>
export default {
  data() {
    return {
      dialog: false,
    };
  },
  props: {
    boxDetails: {
      type: Array,
      required: true,
    },
  },
  methods: {
    async placeRemained(item, isFull) {
      try {
        this.showLoading();
        let params = {
          carriageId: item.id,
          full: isFull,
        };
        await this.$http.post("carriage/full", params);
        item.done = true;
        this.closeIfLastItem();
      } catch (err) {
        this.setResponseError({ error: err });
      } finally {
        this.clearLoading();
      }
    },
    open() {
      this.dialog = true;
    },
    closeIfLastItem() {
      if (this.boxDetails.every((item) => item.done)) {
        this.dialog = false;
        this.$emit("clearProductItemIds");
      }
    },
  },
};
</script>

<style scoped>
.done {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
</style>
